export function toUiErrorMessage(err: unknown): string {
	if (err instanceof Error) {
		return err.message;
	}

	if (typeof err === "object" && err !== null) {
		const record = err as {
			message?: unknown;
			details?: unknown;
			hint?: unknown;
			code?: unknown;
		};

		const parts = [record.message, record.details, record.hint, record.code]
			.filter(
				(part): part is string =>
					typeof part === "string" && part.trim().length > 0,
			)
			.map((part) => part.trim());

		if (parts.length > 0) {
			return parts.join(" | ");
		}
	}

	return "Unknown error";
}
